exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".group__2GL7 {\n  display: flex;\n  justify-content: space-between; }\n", "", {"version":3,"sources":["/app/src/components/input/components/src/components/input/components/RadioGroup.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,+BAA+B,EAChC","file":"RadioGroup.scss","sourcesContent":[".group {\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"group": "group__2GL7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/input/components/RadioGroup.scss
// module id = 814
// module chunks = 0